import React, { FC } from 'react';
import clsx from 'clsx';
import WorkflowStatusIcon from 'app/components/workflowStatus/WorkflowStatusIcon';
import { STATUS } from '@kontentino/kontentino-constants/Posts';

import { CommentConvertor } from 'app/modules/comments/utils/commentConvertor';
import { Comment } from 'app/modules/comments/types';
import { usePostsLayoutState } from 'app/modules/posts/hooks/usePostsLayoutState';
import { useTranslation } from 'react-i18next';

type Props = {
  comment: Comment;
};

const CommentsListItemFooter: FC<Props> = ({
  comment: { type, meta, user },
}) => {
  const { postStatusVariant } = usePostsLayoutState();
  const postStatus = CommentConvertor.commentTypeToStatus(type);
  const { t } = useTranslation();

  const assignedUsersLabel = () => {
    const assignedUsers = meta?.assignedUsers ?? [];

    if (postStatus === STATUS.WAITING_FOR && !!assignedUsers.length) {
      const firstName = assignedUsers[0]?.name ?? '';

      if (assignedUsers.length === 1) {
        return t('assignedToUser', { firstName });
      } else {
        return t('assignedToUserAndMore', {
          firstName,
          count: assignedUsers.length - 1,
        });
      }
    }

    return '';
  };

  return (
    <>
      {postStatus && (
        <div
          className={clsx('tw-mt-1 tw-flex tw-items-center', {
            'tw-mr-10 tw-justify-end': user.its_me,
            'tw-ml-10': !user.its_me,
          })}
        >
          <WorkflowStatusIcon
            status={postStatus}
            variant="regular"
            className="tw-text-sm"
          />
          <span
            className={`tw-text-status-${postStatusVariant}-${postStatus}-primary tw-ml-1 tw-text-sm tw-font-semibold`}
            data-cy="post-comment_status-label"
          >{`${t(
            `workflowStatus.label.${postStatus}`,
          )} ${assignedUsersLabel()}`}</span>
        </div>
      )}
    </>
  );
};

export default CommentsListItemFooter;
